// extracted by mini-css-extract-plugin
module.exports = {"tituloSecao":"ModalMaisDetalhes_tituloSecao__2PSb6","botaoEvento":"ModalMaisDetalhes_botaoEvento__YeIhW"};